export default {
  /* TODO 翻译 */
};
